module.exports = __webpack_public_path__ + "img/badge_color_pop-admission.b3980b61.svg";